import { c as _c } from "react/compiler-runtime";
import React, { useCallback, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ManageEntitiesContentLayout } from 'record-it-components/pageContentLayout/ManageEntitiesContentLayout/ManageEntitiesContentLayout';
import { EntityName } from 'record-it-time-common/EntityName';
import { assertNotNullOrUndefined } from 'record-it-utils/utils/assert/assertNotNullOrUndefined';
import { TimeTrackingConfiguration } from '../../../classes/entities/TimeTrackingConfiguration/timeTrackingConfigurationTypes';
import { UserGroup } from '../../../classes/entities/UserGroup/userGroupTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { useEntities } from '../../../hooks/entity/useEntities/useEntities';
import { useEntityRepository } from '../../../hooks/entity/useEntityRepository';
import { useUserGroupCreateEntityButtonConfig } from '../../../hooks/entity/useUserGroupCreateEntityButtonConfig';
import { useConfigureBreadcrumbsWithBuilder } from '../../../hooks/misc/useConfigureBreadcrumbsWithBuilder';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { TimeTrackingConfigurationList } from '../../timeTrackingConfiguration/TimeTrackingConfigurationList/TimeTrackingConfigurationList';
export type TimeTrackingConfigurationAdminPageProps = {
  children?: Array<never>;
};
export const TimeTrackingConfigurationAdminPage: FunctionComponent<TimeTrackingConfigurationAdminPageProps> = () => {
  const $ = _c(18);
  const timeTrackingConfigurationRepository = useEntityRepository(EntityName.TimeTrackingConfiguration);
  const timeTrackingConfigurations = useEntities(EntityName.TimeTrackingConfiguration, "getAll");
  const {
    t
  } = useTranslation();
  const {
    getRequiredCurrentUserPermissions
  } = useCurrentUser();
  useConfigureBreadcrumbsWithBuilder(_temp);
  let t0;
  if ($[0] !== timeTrackingConfigurationRepository) {
    t0 = userGroup => {
      assertNotNullOrUndefined(userGroup, "can't create a timeTrackingConfiguration without a usergroup");
      timeTrackingConfigurationRepository.create({
        maxWorkHoursPerDay: 10,
        ownerUserGroupId: userGroup.id
      });
    };
    $[0] = timeTrackingConfigurationRepository;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const createConfiguration = t0;
  const renderEntities = _temp2;
  let t1;
  if ($[2] !== t) {
    t1 = t("components.page.TimeTrackingConfigurationAdminPage.createEntity");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== getRequiredCurrentUserPermissions) {
    t2 = getRequiredCurrentUserPermissions().getEditableUserGroupsForTimeTrackingConfigurations();
    $[4] = getRequiredCurrentUserPermissions;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== createConfiguration || $[7] !== t1 || $[8] !== t2) {
    t3 = {
      text: t1,
      userGroups: t2,
      onCreateEntity: createConfiguration
    };
    $[6] = createConfiguration;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const createEntityButtonConfig = useUserGroupCreateEntityButtonConfig(t3);
  let t4;
  if ($[10] !== t) {
    t4 = t("components.page.TimeTrackingConfigurationAdminPage.pageTitle");
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = {
      title: t4,
      iconConfig: iconConfigurations.prefixed.page.TimeTrackingConfigurationAdminPage.titleIcon
    };
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== createEntityButtonConfig || $[15] !== t5 || $[16] !== timeTrackingConfigurations) {
    t6 = <ManageEntitiesContentLayout headerConfig={t5} entities={timeTrackingConfigurations} renderEntities={renderEntities} createEntityButtonConfig={createEntityButtonConfig} />;
    $[14] = createEntityButtonConfig;
    $[15] = t5;
    $[16] = timeTrackingConfigurations;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
function _temp(builder) {
  return builder.addHomePage().addTimeTrackingConfigurationAdminPage();
}
function _temp2(entities) {
  return <TimeTrackingConfigurationList timeTrackingConfigurations={entities} />;
}